export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/map.a1e71d0c.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};